import { createContext, useContext, useState, useCallback } from 'react'
import { getStoredUser, isAuthenticated as checkAuth, login as cognitoLogin, logout as cognitoLogout } from '../services/auth'

const AuthContext = createContext(null)

export function AuthProvider({ children }) {
  const [user, setUser] = useState(getStoredUser)
  const [authenticated, setAuthenticated] = useState(checkAuth)

  const login = useCallback(async (email, password) => {
    const result = await cognitoLogin(email, password)
    setUser(result.user)
    setAuthenticated(true)
    return result
  }, [])

  const logout = useCallback(() => {
    cognitoLogout()
    setUser(null)
    setAuthenticated(false)
  }, [])

  return (
    <AuthContext.Provider value={{ user, authenticated, login, logout }}>
      {children}
    </AuthContext.Provider>
  )
}

export function useAuth() {
  const ctx = useContext(AuthContext)
  if (!ctx) throw new Error('useAuth must be used within AuthProvider')
  return ctx
}
